import React from "react";
import RecoveryPassword from '../components/account/RecoveryPassword';

const PipeIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.1" strokeLinecap="round" strokeLinejoin="round">
    <path d="M3 8h9a3 3 0 0 1 3 3 3 3 0 0 0 3 3h3"/><circle cx="6" cy="16" r="2"/><path d="M8 16h6"/>
  </svg>
);
const MapPinIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>
  </svg>
);
const ClockIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="12" cy="12" r="9"/><path d="M12 7v5l3 2"/>
  </svg>
);
const ShieldIcon = () => (
  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
  </svg>
);

const Account = () => (
  <div className="ds-auth-shell">
    <div className="ds-auth-body">
      <div className="ds-auth-aside">
        <div className="ds-auth-glow" />
        <div className="ds-brand">
          <div className="ds-brand-mark"><PipeIcon /></div>
          <div className="ds-brand-titles">
            <div className="ds-brand-t1">Oldelval <span className="light">· App Externos</span></div>
            <div className="ds-brand-t2">Portal de <b>Solicitudes de Interferencias</b></div>
          </div>
        </div>
        <div style={{ position: 'relative' }}>
          <h2>Recuperá el acceso a tu cuenta</h2>
          <p>Ingresá tu CUIT o email y tu nueva contraseña. Te enviaremos un token de verificación.</p>
        </div>
        <div className="ds-auth-feats">
          <div className="ds-auth-feat"><div className="ic"><MapPinIcon /></div><div className="tx"><b>Proceso seguro</b><span>Verificación por token enviado al correo registrado.</span></div></div>
          <div className="ds-auth-feat"><div className="ic"><ClockIcon /></div><div className="tx"><b>Rápido</b><span>En menos de 5 minutos podés volver a operar.</span></div></div>
          <div className="ds-auth-feat"><div className="ic"><ShieldIcon /></div><div className="tx"><b>Tus datos protegidos</b><span>Plataforma con cifrado de extremo a extremo.</span></div></div>
        </div>
      </div>
      <div className="ds-auth-form-col">
        <div className="ds-auth-form">
          <RecoveryPassword />
        </div>
      </div>
    </div>
  </div>
);

export default Account;
